<template>
  <vk-modal @close="$emit('close')">
    <vk-modal-body>
      <vk-modal-header class="text-center text-bold p-l-6">
        We’ve matched you with these local Pros:
      </vk-modal-header>
      <vk-modal-content class="p-0">
        <pro-list-item
            v-for="match in loadedMatches"
            :key="match.id"
            :match="match"
            :is-unreachable-match="getIsUnreachableMatch(match)"
            :is-active-match="getIsActiveMatch(match)"
            :pro="getPro(match.service_provider_user_identifier)"
            class="bd-b-gray40"
            @click.native="$emit('match-clicked', match)"/>
      </vk-modal-content>
      <vk-modal-footer class="d-flex jc-center">
        <input
            class="BUTTON btn w-100:mo"
            type="button"
            value="Okay"
            selenium="pro-list-modal-button"
            @click="$emit('close')">
      </vk-modal-footer>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ProListItem from './components/ProListItem';

export default {
  name: 'all-matched-pros-modal',
  components: {
    ProListItem,
  },
  props: {
    matches: {
      type: Array,
      required: true,
    },
    getIsUnreachableMatch: {
      type: Function,
      required: true,
    },
    getIsActiveMatch: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('dashboard/publicProfile', [
      'getPublicProfileByServiceProviderIdentifier',
    ]),
    loadedMatches () {
      return this.matches.filter(match => this.getPro(match.service_provider_user_identifier));
    },
  },
  methods: {
    getPro (serviceProviderId) {
      return this.getPublicProfileByServiceProviderIdentifier(serviceProviderId);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .BUTTON {
    min-width: 250px;
  }
</style>
